import { combineReducers } from '@reduxjs/toolkit';

import {
  meetingsApi,
  racesApi,
  userApi,
  partnersApi,
  raceApi,
  racePreviewApi,
  eventsApi,
  oddsApi,
  runnersApi,
  performancesApi,
  editorialContentsApi,
  fixedOddsApi,
} from '@api/services';

import { authReducer } from './slices/authSlice';
import { raceEventsReducer } from './slices/events';
import { reducer as toastReducer } from './slices/toastSlice';

// Create the root reducer separately so we can extract the RootState type
export const rootReducer = combineReducers({
  // Add the generated reducer as a specific top-level slices
  [meetingsApi.reducerPath]: meetingsApi.reducer,
  [racesApi.reducerPath]: racesApi.reducer,
  [raceApi.reducerPath]: raceApi.reducer,
  [racePreviewApi.reducerPath]: racePreviewApi.reducer,
  [runnersApi.reducerPath]: runnersApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [partnersApi.reducerPath]: partnersApi.reducer,
  [oddsApi.reducerPath]: oddsApi.reducer,
  [eventsApi.reducerPath]: eventsApi.reducer,
  [editorialContentsApi.reducerPath]: editorialContentsApi.reducer,
  [performancesApi.reducerPath]: performancesApi.reducer,
  [fixedOddsApi.reducerPath]: fixedOddsApi.reducer,
  auth: authReducer,
  raceEvents: raceEventsReducer,
  toast: toastReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
